const AlertIcon = ({ darkMode }) => {
  return (
    <svg
      className={`${darkMode ? 'text-white' : 'text-[#27292C]'} mr-4 h-6`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 3.5c.3 0 .6.16.76.43l8.06 14.01a.88.88 0 0 1-.76 1.32H3.94a.88.88 0 0 1-.76-1.32l8.06-14.01A.88.88 0 0 1 12 3.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="12"
        y1="9"
        x2="12"
        y2="13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="12"
        cy="16"
        r="1"
        fill="currentColor"
      />
    </svg>
  );
};

export default AlertIcon;
